// **************************************************
// Change title font size
// **************************************************

const scrollTitles = document.querySelectorAll('.sc-title .title h2');

scrollTitles.forEach((scrollTitle) => {
  let classA = '';

  switch (true) {
    case scrollTitle.innerHTML.length > 50:
      classA = 'smaller';
      break;
    case scrollTitle.innerHTML.length > 25:
      classA = 'small';
      break;
    default:
      break;
  }

  if (classA) {
    scrollTitle.classList.add(classA);
  }
});
